<template>
    <div>
        <span class="caption grey--text text--lighten-1">
            {{label}}
        </span>
        <v-list-item class="pl-2" @click="openSelector" v-if="selectedClient">
            <v-list-item-avatar>
                <v-icon>mdi-domain</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                {{selectedClient.name}}
            </v-list-item-content>
            <v-list-item-action>

                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click.stop="removeClientClicked"
                               icon
                               text
                               v-on="on"
                               color="secondary">
                            <v-icon light small color="white">mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Remove client</span>
                </v-tooltip>

            </v-list-item-action>
        </v-list-item>

        <!-- UNSELECTED STATE -->
        <v-list-item class="pl-2" v-if="!selectedClient" @click="openSelector">
            <v-list-item-avatar>
                <v-icon color="grey">mdi-domain</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                Click to select
            </v-list-item-content>

        </v-list-item>

        <!-- CLIENT SELECTION DIALOG -->
        <v-dialog v-model="dialogModel" max-width="400">

            <toolbar-page :title="menuTitle">
                <template slot="buttons">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="closeSelector()" v-on="on" icon>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close client selection</span>
                    </v-tooltip>
                </template>
            </toolbar-page>

            <v-list two-line>

                <v-subheader v-show="subTitle">{{subTitle}}</v-subheader>

                <v-card flat>
                    <v-card-text v-if="clients.length === 0 && clientsLoading === false">
                        <v-alert
                                color="info"
                                :value="true">
                            No clients found
                        </v-alert>
                    </v-card-text>
                </v-card>

                <template v-if="!clientsLoading" v-for="(client,index) in clients">
                    <v-list-item @click="clientSelected(client)">
                        <v-list-item-avatar>
                            <v-icon>mdi-domain</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{client.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{client.primary_contact_name}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon v-if="selectedClient && selectedClient.id === client.id">mdi-star</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider v-show="clients.length > index + 1"></v-divider>
                </template>

                <v-card flat>
                    <v-card-text v-if="clientsLoading" class="text-md-center">
                        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                    </v-card-text>
                </v-card>

            </v-list>
        </v-dialog>
    </div>
</template>

<script>

    import Json from 'vue-json-pretty';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import Avatar from './Avatar';
    import ToolbarPage from './ToolbarPage';

    const vuexModule = 'Clients';

    export default {

        components: {
            Json,
            Avatar,
            ToolbarPage
        },

        props: {
            selectedClient: {
                type: Object,
                required: false,
                default: () => null,
            },
            excludeClient: {
                type: Object,
                required: false,
                default: () => null,
            },
            label: {
                type: String,
                required: false,
                default: 'Client selection'
            },
            menuTitle: {
                type: String,
                required: false,
                default: 'Client selection'
            },
            subTitle: {
                type: String,
                required: false,
                default: null
            }
        },

        data() {
            return {
                minPermission: 'View Clients',
                dialogModel: false
            }
        },
        computed: {
            ...mapState(vuexModule, [
                'clients',
                'clientsLoading'
            ]),
        },

        methods: {
            ...mapActions(vuexModule, [
                'getClients'
            ]),

            ...mapMutations(vuexModule, []),

            openSelector() {
                this.loadData();
                this.dialogModel = true;
            },
            closeSelector() {
                this.dialogModel = false;
            },

            loadData(force = false) {
                this.getClients(force)
                    .catch(() => {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'Oops. We failed to load clients! Please try again!'
                        });
                    })
            },

            clientSelected(client) {
                this.$emit('change', Object.assign({}, client));
                this.closeSelector();
            },

            removeClientClicked() {
                this.$emit('change', null);
            }
        },
    }

</script>
